<!-- Superposición de fondo -->
<div class="modal-overlay w-2/3" (click)="closeSparePartModal()"></div>

<!-- Contenedor del modal -->
<div class="modal-box">
  <div class="modal-content p-4">
    <span class="close-button" (click)="closeSparePartModal()">&times;</span>
    <div class="flex justify-between items-center pr-8 mb-3">
      <h3 class="font-bold text-lg">Editar Repuesto</h3>
      <button type="button" class="btn btn-sm" (click)="toggleAldanaForm()">Aldana</button>
    </div>
    <form>
      <div>
        <div *ngIf="showAldanaForm" class="border rounded-md p-3 mb-4 bg-gray-50">
          <div class="mb-3">
            <label for="interno" class="form-label">Interno</label>
            <input type="text" class="form-control input input-bordered w-full" id="interno"
              [(ngModel)]="newSparePart.interno" name="interno">
          </div>
          <div class="mb-3">
            <label for="externo" class="form-label">Externo</label>
            <input type="text" class="form-control input input-bordered w-full" id="externo"
              [(ngModel)]="newSparePart.externo" name="externo">
          </div>
          <div class="mb-3">
            <label for="fechaDeComunicado" class="form-label">Fecha de comunicado</label>
            <input type="date" class="form-control input input-bordered w-full" id="fechaDeComunicado"
              [(ngModel)]="aldanaFechaComunicadoInput" name="fechaDeComunicado">
          </div>
          <div class="mb-1">
            <label class="form-label">Color</label>
          </div>
          <div class="flex flex-wrap gap-2">
            <button *ngFor="let color of aldanaColorOptions"
              type="button"
              class="w-8 h-8 border rounded"
              [title]="color.name"
              [ngStyle]="{
                'background-color': color.hex,
                'border-color': newSparePart.color === color.value ? '#2563eb' : '#9ca3af',
                'box-shadow': newSparePart.color === color.value ? '0 0 0 2px rgba(37,99,235,0.35)' : 'none'
              }"
              (click)="selectAldanaColor(color.value)">
            </button>
          </div>
        </div>

        <!-- Campos del formulario -->
        <div class="mb-3">
          <label for="sparePartName" class="form-label">Nombre del Repuesto (General)</label>
          <input type="text" class="form-control input input-bordered w-full" id="sparePartName"
            [(ngModel)]="newSparePart.sparePartName" name="sparePartName">
        </div>

        <div class="mb-3">
          <label for="sparePartNameEs" class="form-label">Nombre en Español (Para etiquetas)</label>
          <input type="text" class="form-control input input-bordered w-full" id="sparePartNameEs"
            [(ngModel)]="newSparePart.sparePartNameEs" name="sparePartNameEs" placeholder="Nombre en español">
        </div>

        <div class="mb-3">
          <label for="sparePartNamePt" class="form-label">Nombre en Portugués (Para Excel)</label>
          <input type="text" class="form-control input input-bordered w-full" id="sparePartNamePt"
            [(ngModel)]="newSparePart.sparePartNamePt" name="sparePartNamePt" placeholder="Nome em português">
        </div>
        <!-- Resto de campos... -->
        <div class="mb-3">
          <label for="productCode" class="form-label">Código del Repuesto</label>
          <input type="text" class="form-control input input-bordered w-full" id="productCode"
            [(ngModel)]="newSparePart.productCode" name="productCode">
        </div>
        <div class="mb-3">
          <label for="providerName" class="form-label">Proveedor del repuesto</label>
          <input type="text" class="form-control input input-bordered w-full" id="providerName"
            [(ngModel)]="newSparePart.providerName" name="providerName">
        </div>
        <div class="form-control mb-3">
          <label class="label" for="returnStatus">
            <span class="label-text">Estado de devolución</span>
          </label>
          <select id="returnStatus" [(ngModel)]="newSparePart.returnStatus" class="select select-bordered" name="returnStatus">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div class="form-control mb-3">
          <label class="label" for="returnLogStatus">
            <span class="label-text">Estado de devolución LOG</span>
          </label>
          <select id="returnLogStatus" [(ngModel)]="newSparePart.returnLogStatus" class="select select-bordered" name="returnLogStatus">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnLogStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div class="form-control mb-3">
          <label class="label" for="returnReason">
            <span class="label-text">Motivo devolución</span>
          </label>
          <select id="returnReason" [(ngModel)]="newSparePart.returnReason" class="select select-bordered" name="returnReason">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnReasonOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div class="form-control mb-3">
          <label class="label" for="returnCarrier">
            <span class="label-text">Transportadoras</span>
          </label>
          <select id="returnCarrier" [(ngModel)]="newSparePart.returnCarrier" class="select select-bordered" name="returnCarrier">
            <option value="">Sin definir</option>
            <option *ngFor="let option of returnCarrierOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="nfd" class="form-label">NFD</label>
          <input type="text" class="form-control input input-bordered w-full" id="nfd"
            [(ngModel)]="newSparePart.nfd" name="nfd">
        </div>
        <div class="form-control mb-3">
          <label class="label" for="mlStatus">
            <span class="label-text">Situación ML</span>
          </label>
          <select id="mlStatus" [(ngModel)]="newSparePart.mlStatus" class="select select-bordered" name="mlStatus">
            <option value="">Sin definir</option>
            <option *ngFor="let option of mlStatusOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="mlDeadline" class="form-label">Prazo ML</label>
          <input type="date" class="form-control input input-bordered w-full" id="mlDeadline"
            [(ngModel)]="newSparePartMlDeadline" name="mlDeadline">
        </div>
        <div class="form-control mb-3">
          <label class="label" for="freteDev">
            <span class="label-text">FRETE DEV</span>
          </label>
          <select id="freteDev" [(ngModel)]="newSparePart.freteDev" class="select select-bordered" name="freteDev">
            <option value="">Sin definir</option>
            <option *ngFor="let option of freteDevOptions" [value]="option">{{ option }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="newOrderNumber" class="form-label">Orden Nueva</label>
          <input type="text" class="form-control input input-bordered w-full" id="newOrderNumber"
            [(ngModel)]="newSparePart.newOrderNumber" name="newOrderNumber" placeholder="Opcional">
        </div>
        <div class="mb-3">
          <label for="amount" class="form-label">Cantidad</label>
                      <input type="text" class="form-control input input-bordered w-full" id="amount"
            [(ngModel)]="newSparePart.amount" name="amount" 
            (input)="handleNumericInput($event)"
            (blur)="handleNumericBlur($event)"
            (focus)="handleNumericFocus($event)"
            placeholder="1">
        </div>
        <div class="mb-3">
          <label for="unitPrice" class="form-label">Costo Unitario</label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">R$</span>
            <input type="text" class="form-control input input-bordered w-full pl-8" id="unitPrice"
              [(ngModel)]="newSparePart.unitPrice" name="unitPrice" 
              (input)="handleNumericInput($event)"
              (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)"
              placeholder="0,00">
          </div>
        </div>
        <div class="mb-3">
          <label for="valorDeVenta" class="form-label">Valor de Venta</label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">$</span>
            <input type="text" class="form-control input input-bordered w-full pl-6" id="valorDeVenta"
              [(ngModel)]="newSparePart.valorDeVenta" name="valorDeVenta" 
              (input)="handleNumericInput($event)"
              (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)"
              placeholder="0,00">
          </div>
        </div>
        <div class="mb-3">
          <label for="ncm" class="form-label">NCM</label>
          <input type="text" class="form-control input input-bordered w-full" id="ncm"
            [(ngModel)]="newSparePart.ncm" name="ncm">
        </div>

        
        <div class="mb-3">
          <label for="returnDetails" class="form-label">Detalles Adicionales</label>
          <textarea id="returnDetails" class="form-control textarea textarea-bordered w-full" rows="2"
            [(ngModel)]="newSparePart.returnDetails" name="returnDetails"
            placeholder="Detalles de la devolución (opcional)"></textarea>
        </div>

        <div class="mb-3">
          <label for="codBr" class="form-label">Código BR</label>
          <input type="text" class="form-control input input-bordered w-full" id="codBr"
            [(ngModel)]="newSparePart.codBr" name="codBr">
        </div>
        <div class="mb-3">
          <label for="netWheight" class="form-label">Peso Líquido</label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">kg</span>
            <input type="text" class="form-control input input-bordered w-full pl-10" id="netWheight"
              [(ngModel)]="newSparePart.netWheight" name="netWheight" 
              (input)="handleNumericInput($event)"
              (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)"
              placeholder="0,00">
          </div>
        </div>
        <div class="mb-3">
          <label for="grossWheight" class="form-label">Peso Bruto</label>
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-500">kg</span>
            <input type="text" class="form-control input input-bordered w-full pl-10" id="grossWheight"
              [(ngModel)]="newSparePart.grossWheight" name="grossWheight" 
              (input)="handleNumericInput($event)"
              (blur)="handleNumericBlur($event)"
              (focus)="handleNumericFocus($event)"
              placeholder="0,00">
          </div>
        </div>
        <div class="form-control">
          <label class="label" for="productStatus">
            <span class="label-text">Estado del Producto</span>
          </label>
          <select id="productStatus" [(ngModel)]="newSparePart.productStatus" class="select select-bordered" name="productStatus">
            <option *ngFor="let status of filteredSparePartDeliveryStatus" [value]="status">{{ status }}</option>
          </select>
        </div>
        
        <!-- Campo PackageNumber - Solo lectura -->
        <div class="mb-3">
          <label for="packageNumber" class="form-label">Número de Paquete</label>
          <input type="text" class="form-control input input-bordered w-full bg-gray-100" id="packageNumber"
            [(ngModel)]="newSparePart.packageNumber" name="packageNumber" readonly
            placeholder="Se asignará automáticamente al generar etiquetas">
        </div>
        
        <div class="mb-3">
          <label for="comments" class="form-label">Comentarios</label>
          <input type="text" class="form-control input input-bordered w-full" id="comments"
            [(ngModel)]="newSparePart.comments" name="comments">
        </div>
        <div class="form-control mb-3">
          <label class="label" for="isDamaged">
            <span class="label-text">¿Está dañado?</span>
          </label>
          <select id="isDamaged" [(ngModel)]="newSparePart.isDamaged" class="select select-bordered" name="isDamaged">
            <option *ngFor="let option of damagedStateOptions" [value]="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="mb-3">
          <label for="taxNote" class="form-label">Nota Fiscal</label>
          <input type="text" class="form-control input input-bordered w-full" id="taxNote"
            [(ngModel)]="newSparePart.taxNote" name="taxNote">
        </div>
        <div class="form-control mb-3">
          <div class="flex flex-wrap items-center gap-2">
            <label class="label cursor-pointer justify-start gap-2 py-0" for="isFant">
              <input type="checkbox" id="isFant" [(ngModel)]="newSparePart.isFant" name="isFant"
                class="checkbox checkbox-primary" (ngModelChange)="onFantCheckboxChanged($event)">
              <span class="label-text">Fant?</span>
            </label>
            <span class="inline-flex items-center gap-1" *ngIf="newSparePart.isFant">
              <button type="button" title="Puede esperar" (click)="setFantUrgency('green')"
                class="w-4 h-4 rounded-full bg-green-500 border-2"
                [class.border-gray-900]="newSparePart.fantUrgency === 'green'"
                [class.border-transparent]="newSparePart.fantUrgency !== 'green'"
                [class.ring-2]="newSparePart.fantUrgency === 'green'"
                [class.ring-green-800]="newSparePart.fantUrgency === 'green'"></button>
              <button type="button" title="Atención" (click)="setFantUrgency('yellow')"
                class="w-4 h-4 rounded-full bg-yellow-400 border-2"
                [class.border-gray-900]="newSparePart.fantUrgency === 'yellow'"
                [class.border-transparent]="newSparePart.fantUrgency !== 'yellow'"
                [class.ring-2]="newSparePart.fantUrgency === 'yellow'"
                [class.ring-yellow-700]="newSparePart.fantUrgency === 'yellow'"></button>
              <button type="button" title="Urgente" (click)="setFantUrgency('red')"
                class="w-4 h-4 rounded-full bg-red-500 border-2"
                [class.border-gray-900]="newSparePart.fantUrgency === 'red'"
                [class.border-transparent]="newSparePart.fantUrgency !== 'red'"
                [class.ring-2]="newSparePart.fantUrgency === 'red'"
                [class.ring-red-800]="newSparePart.fantUrgency === 'red'"></button>
            </span>
          </div>
        </div>
        <div class="form-control mb-3">
          <label class="label cursor-pointer" for="recompra">
            <span class="label-text">Recompra</span>
            <input type="checkbox" id="recompra" [(ngModel)]="newSparePart.recompra" name="recompra"
              class="checkbox checkbox-warning">
          </label>
        </div>
        <div class="mb-3">
          <div class="form-control">
            <label class="label" for="arrivalDays">
              <span class="label-text">Días hasta la llegada esperada</span>
            </label>
            <!-- Input para ingresar la cantidad de días -->
            <input
              type="number"
              id="arrivalDays"
              [(ngModel)]="arrivalDays"
              class="input input-bordered"
              placeholder="Ingrese días"
              #daysUntilArrive
              name="arrivalDays"
            />

            
          </div>
        </div>
      </div>
    </form>
    <div class="modal-action sticky bottom-0 bg-white border-t pt-3 mt-4 z-10">
      <button class="btn cancel-button" (click)="closeSparePartModal()">Cerrar</button>
      <button class="btn confirm-button" (click)="addSparePart()">Agregar repuesto</button>
    </div>
  </div>
</div>
